// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import useUuid from '../../../../../hooks/useUuid';
import BoomUIBySkinId from '../../../constants/ui';
import { type BoomSkinId } from '../../../types/global';
import { BoomStepStatuses, type BoomStepStatus } from '../../../types/steps';

const Wrapper = styled.div``;

const SvgElement = styled.svg`
  height: 100%;
  width: 100%;

  ${({ $isInProgress, $skinId }) => {
    const svgStyle = BoomUIBySkinId[$skinId]?.STEP_CIRCLE_STYLE[$isInProgress ? 'inProgress' : 'default'];

    if ($isInProgress) {
      return css`
        --boom-step-circle-fill-color: ${svgStyle.fillColor};
        --boom-step-circle-fill-opacity: ${svgStyle.fillOpacity};
        --boom-step-circle-fill-stop-opacity: ${svgStyle.fillStopOpacity ?? 0};
        --boom-step-circle-stroke-color: ${svgStyle.strokeColor};
      `;
    }

    return css`
      --boom-step-circle-fill-color: ${svgStyle.fillColor};
      --boom-step-circle-fill-opacity: ${svgStyle.fillOpacity};
      --boom-step-circle-fill-stop-opacity: ${svgStyle.fillStopOpacity ?? 0};
      --boom-step-circle-stroke-color: ${svgStyle.strokeColor};
    `;
  }}
`;

const CircleRectElement = styled.rect`
  fill-opacity: var(--boom-step-circle-fill-opacity);
`;

const FillStopGradient = styled.stop`
  stop-color: var(--boom-step-circle-fill-color);
`;

const FillStopOpacityGradient = styled.stop`
  stop-color: var(--boom-step-circle-fill-color);
  stop-opacity: var(--boom-step-circle-fill-stop-opacity);
`;

const StrokeStopGradient = styled.stop`
  stop-color: var(--boom-step-circle-stroke-color);
`;

type PropsType = {
  className?: string;
  status: BoomStepStatus;
  skinId: BoomSkinId;
};

const BoomHalloweenStepCircleSvgAsComponent = ({ className = '', status, skinId }: PropsType) => {
  const isCompleted = useMemo(() => status === BoomStepStatuses.WON, [status]);
  const isInProgress = useMemo(() => status === BoomStepStatuses.PENDING || status === BoomStepStatuses.OPEN, [status]);

  const uuid = useUuid();

  return (
    <Wrapper className={className}>
      <SvgElement
        $skinId={skinId}
        $isInProgress={isInProgress}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {isCompleted ? (
          <>
            <rect
              x="0.5"
              y="0.5"
              width="29"
              height="29"
              rx="14.5"
              fill={`url(#completed-boom-step-circle-fill-gradient-${uuid})`}
            />
            <path d="M9 15L13 19L21 11" stroke="#0A2919" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            <rect
              x="0.5"
              y="0.5"
              width="29"
              height="29"
              rx="14.5"
              stroke={`url(#completed-boom-step-circle-stroke-gradient-${uuid})`}
            />
            <defs>
              <linearGradient
                id={`completed-boom-step-circle-fill-gradient-${uuid}`}
                x1="15"
                y1="0"
                x2="15"
                y2="20.4"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0A2919" />
                <stop offset="1" stopColor="#5CD699" />
              </linearGradient>
              <linearGradient
                id={`completed-boom-step-circle-stroke-gradient-${uuid}`}
                x1="15"
                y1="0"
                x2="15"
                y2="30"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="white" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
              </linearGradient>
            </defs>
          </>
        ) : (
          <>
            <CircleRectElement
              x="0.5"
              y="0.5"
              width="29"
              height="29"
              rx="14.5"
              fill={`url(#default-boom-step-circle-fill-gradient-${uuid})`}
            />
            <rect
              x="0.5"
              y="0.5"
              width="29"
              height="29"
              rx="14.5"
              stroke={`url(#default-boom-step-circle-stroke-gradient-${uuid})`}
            />
            <defs>
              <radialGradient
                id={`default-boom-step-circle-fill-gradient-${uuid}`}
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(14.0625 15) rotate(131.855) scale(20.1387 440.911)"
              >
                <FillStopOpacityGradient />
                <FillStopGradient offset="1" />
              </radialGradient>
              <linearGradient
                id={`default-boom-step-circle-stroke-gradient-${uuid}`}
                x1="27.125"
                y1="2.5"
                x2="15.4485"
                y2="19.1049"
                gradientUnits="userSpaceOnUse"
              >
                <StrokeStopGradient />
                <StrokeStopGradient offset="1" stopOpacity="0" />
              </linearGradient>
            </defs>
          </>
        )}
      </SvgElement>
    </Wrapper>
  );
};

export default BoomHalloweenStepCircleSvgAsComponent;
